import(/* webpackMode: "eager" */ "/codebuild/output/src1810816620/src/helloero-new/packages/helloero/src/app/error.tsx");
